<!-- <div id="container" style="min-width: 310px; height: 400px; margin: 0 auto"></div> -->
<div class="dial-guage">
  <div [attr.id]="chartId"></div>
</div>
